// extracted by mini-css-extract-plugin
export default {"shell":"ClientNotesPanel_shell__t2zyN","card":"ClientNotesPanel_card__jd-5J","addForm":"ClientNotesPanel_addForm__hBDBI","emptyState":"ClientNotesPanel_emptyState__GWzBd"};